import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { ArrowLeft, RefreshCw } from "lucide-react";
import { API } from "@/auth";
import useSeo from "@/seo";

export default function CommonNumbers() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const nav = useNavigate();

  useSeo({
    title: "Common Number Today | Morning Sunday Teer",
    description: "Latest Morning Sunday Teer common numbers with Direct, House and Ending values, updated every day.",
    path: "/common-numbers",
  });

  const load = () => {
    setLoading(true);
    axios
      .get(`${API}/common-numbers/latest`)
      .then((r) => setData(r.data))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    document.title = "Common Number | Morning Sunday Teer";
    load();
  }, []);  const s1 = data?.section1 || { direct: "--", house: "--", ending: "--" };
  const s2 = data?.section2 || { direct: "--", house: "--", ending: "--" };
  const formatDate = (raw) => {
    if (!raw) return "";
    const iso = /^\d{4}-\d{2}-\d{2}$/.exec(raw);
    if (iso) { const [y, m, d] = raw.split("-"); return `${d}/${m}/${y}`; }
    return raw;
  };
  const dateText = data?.date ? `MORNING SUNDAY TEER — ${formatDate(data.date)}` : "MORNING SUNDAY TEER";

  return (
    <div className="cn-shell" data-testid="common-numbers-page">
      <div className="cn-container">
        <button
          className="cn-back"
          data-testid="cn-back-button"
          onClick={() => nav("/")}
        >
          <ArrowLeft /> Back
        </button>

        <div className="cn-title">
          <h1 data-testid="cn-heading">Common Number</h1>
          <button
            className="cn-refresh"
            data-testid="cn-refresh-button"
            onClick={load}
            aria-label="Refresh"
          >
            <RefreshCw />
          </button>
        </div>

        <div className="cn-card" data-testid="cn-table-card">
          <div className="cn-date" data-testid="cn-date-header">
            {loading ? "Loading..." : dateText}
          </div>

          <div className="cn-section" data-testid="cn-section-1">
            <div className="cn-section-head">
              <span>Direct</span>
              <span>House</span>
              <span>Ending</span>
            </div>
            <div className="cn-section-body">
              <span data-testid="cn-s1-direct">{s1.direct || "--"}</span>
              <span data-testid="cn-s1-house">{s1.house || "--"}</span>
              <span data-testid="cn-s1-ending">{s1.ending || "--"}</span>
            </div>
          </div>

          <div className="cn-section cn-section--alt" data-testid="cn-section-2">
            <div className="cn-section-head">
              <span>Direct</span>
              <span>House</span>
              <span>Ending</span>
            </div>
            <div className="cn-section-body">
              <span data-testid="cn-s2-direct">{s2.direct || "--"}</span>
              <span data-testid="cn-s2-house">{s2.house || "--"}</span>
              <span data-testid="cn-s2-ending">{s2.ending || "--"}</span>
            </div>
          </div>
        </div>

        <p className="cn-footnote" data-testid="cn-updated">
          {data?.updated_at
            ? `Last updated: ${new Date(data.updated_at).toLocaleString()}`
            : "Awaiting the first published update."}
        </p>
      </div>
    </div>
  );
}
